export default "__VITE_ASSET__DvlPJHcT__"